module.exports = __webpack_public_path__ + "static/hero-0757d9366ca39a856ab0adfeab253341.jpg";